export default "__VITE_ASSET__Co528UA2__"